import cfg from 'cfg';
import auth from 'dash-front/auth';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { USER_ACTIONS } from '../../reducers/user';

const radioButtonStyles = {
    marginBottom: 16,
};

class TemplatesList extends Component {
    state = {
        defaultTemplateId: (this.props.user && this.props.user.defaultTemplateId) || '',
        templates: [],
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        fetch(`${cfg.dash.api.host}/api/templates/list?access_token=${auth.getAccessToken()}`)
            .then(res => res.json())
            .then(templates => {
                this.setState({ templates });
            })
            .catch(error => {
                console.error(error);
            });
    };

    handleTemplateSetDefault = (event, defaultTemplateId) => {
        const { _id: userId } = this.props.user;

        return fetch(`${cfg.dash.api.host}/api/users/${userId}?access_token=${auth.getAccessToken()}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                defaultTemplateId,
            }),
        })
            .then(res => res.json())
            .then(() => {
                auth.saveUser({ ...this.props.user, defaultTemplateId });
                this.props.updateUser({ ...this.props.user, defaultTemplateId });

                this.setState({
                    defaultTemplateId,
                });
            })
            .catch(error => {
                console.error(error);
            });
    };

    render() {
        return (
            <div>
                <RadioButtonGroup
                    name="template_default"
                    defaultSelected={this.state.defaultTemplateId}
                    onChange={this.handleTemplateSetDefault}
                >
                    {this.state.templates
                        .filter(({ isHidden }) => !isHidden)
                        .map(({ id, name }) => (
                            <RadioButton key={id} value={id} label={name} style={radioButtonStyles} />
                        ))}
                </RadioButtonGroup>
            </div>
        );
    }
}

TemplatesList.defaultProps = { user: { defaultTemplateId: '' } };

TemplatesList.propTypes = {
    user: PropTypes.shape({
        defaultTemplateId: PropTypes.string,
    }).isRequired,
    updateUser: PropTypes.func.isRequired,
};

export default connect(
    ({ user }) => ({ user }),
    {
        updateUser: user => ({ type: USER_ACTIONS.UPDATE, payload: user }),
    },
)(TemplatesList);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/account/TemplatesList.js
 **/